import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
@Injectable({
  providedIn: 'root',
})
export class DataService {
  private changeProfile: any = new BehaviorSubject({ url: '' })
  profileChange: any = this.changeProfile.asObservable()

  private updateProfile: any = new BehaviorSubject({
    first_name: '',
    last_name: '',
    email: '',
    logo: '',
  })
  updateChange: any = this.updateProfile.asObservable()

  private changeLogo: any = new BehaviorSubject({ url: '' })
  logo: any = this.changeLogo.asObservable()

  private changeVideo: any = new BehaviorSubject({ url: '' })
  videoChange: any = this.changeVideo.asObservable()

  private navigation: any = new BehaviorSubject({ status: '' })
  navigationChange: any = this.navigation.asObservable()

  private changeCredential: any = new BehaviorSubject({ url: '' })
  credentialChange: any = this.changeCredential.asObservable()

  private messageSource = new BehaviorSubject('default message')
  currentMessage = this.messageSource.asObservable()

  changeLogoService(data: any): void {
    this.changeLogo.next(data)
  }

  changeProfileService(data: any): void {
    this.changeProfile.next(data)
  }

  updateProfileService(data: any): void {
    this.updateProfile.next(data)
  }
  navigationBar(data: any): void {
    this.navigation.next(data)
  }
  changeCredentialService(data: any): void {
    this.changeCredential.next(data)
  }
  changeVideoService(data: any): void {
    this.changeVideo.next(data)
  }

  changeMessage(message: string) {
    this.messageSource.next(message)
  }

  changeLocalData(message: string): any {
    this.messageSource.next(message)
  }
}
